import WarningCard from 'app/shared-components/WarningCard'
import {
    WarningCardVariant,
} from 'app/enums/common.enums'

import useStyles from './PopupWarning.styles'

const PopupWarning = () => {
    const {
        classes,
    } = useStyles()

    return (
        <WarningCard
            variant={WarningCardVariant.Warning}
            classNames={{
                container: classes.container,
                text: classes.text,
            }}
        >
            <span className={classes.bold}>IMPORTANT: </span>
            You are about to perform a bulk update of Lane Fee statuses, affecting
            all selected fees regardless of their current state, under these conditions:
            <ul>
                <li>
                    Validity can only be extended for fees that expired less than a year ago
                </li>
                <li>
                    Valid To date will only be updated if a new date is later than the existing one.
                </li>
            </ul>
            If you are unsure, please review and adjust your selection.
        </WarningCard>
    )
}

export default PopupWarning
